import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Animation library - https://animate.style/
import "animate.css/animate.min.css";

//filters
import "@/filters/index.js";

//plugins
import "@/plugins/vee-validate";
import "@/plugins/moment";
import { auth } from "@/plugins/db";
import { i18n } from "@/plugins/i18n";
import vuetify from "@/plugins/vuetify";
import "@/plugins/vuetify-dialog";
import "@/plugins/date-time-picker";
import "@/plugins/base";
import "@/plugins/chartist";
import "@/plugins/export-2-excel";
import "@/plugins/animate";
import "@/plugins/clipboard";
import "@/plugins/global-components";
import "@/plugins/vue-the-mask";
import "@/plugins/apex-charts";
import "@/plugins/vue-tour";
import "@/plugins/vuesax";
import "@/plugins/vueplyr";
import "@/plugins/vue-geolocation";

Vue.config.devtools = true;
Vue.config.productionTip = false;

import { TiptapVuetifyPlugin } from "tiptap-vuetify";
Vue.use(TiptapVuetifyPlugin, { vuetify, iconsGroup: "mdiSvg" });

// Service Worker
import "./registerServiceWorker";

let app;
auth.onAuthStateChanged(async user => {
  if (!app) {
    if (user) {
      await store.dispatch("auth/CALL_DATA");
      await store.commit("auth/SET_LOGIN", user);
      await store.dispatch("auth/TRAER_USUARIO", user.uid);
      app = new Vue({
        router,
        store,
        i18n,
        vuetify,
        render: h => h(App)
      }).$mount("#app");
    } else {
      app = new Vue({
        router,
        store,
        i18n,
        vuetify,
        render: h => h(App)
      }).$mount("#app");
    }
  }
});
